import React from "react";
import Navbar from "../Components/Navbar";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "../CSS/designCompetition.css";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify";

const BikeDesignCompScreen = () => {
  return (
    <div>
      <Navbar />
      <div className="w-100 position-relative">
        <picture className="main-banner-img">
          <source
            media="(max-width:650px)"
            srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/designCompetition/firstFoldMobile.png"
          />
          <source
            media="(min-width:651px)"
            srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/designCompetition/firstFoldDesktop.png"
          />
          <LazyLoadImage
            src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/designCompetition/firstFoldDesktop.png"
            alt="Banner1"
            className="d-block w-100"
          />
        </picture>
        <div
          className="position-absolute d-lg-none metropolis-medium"
          style={{ top: "80%", left: "5%" }}
        >
          <small>Lil E Kick Scooter</small>
        </div>
        <div
          className="position-absolute d-lg-none metropolis-medium"
          style={{ top: "75%", left: "38%" }}
        >
          <small>EMotorad X1</small>
        </div>
        <div
          className="position-absolute d-lg-none metropolis-medium"
          style={{ top: "82%", right: "5%" }}
        >
          <small>₹10,000 Cash Prize</small>
        </div>
      </div>
      <div className="container px-0">
        <div className="row justify-content-center align-items-center my-5 py-lg-4">
          <div className="col-12 col-md-4 my-lg-5 mb-4 mb-lg-0">
            <div className="position-relative">
              <LazyLoadImage
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/designCompetition/secondFoldBehindWebBreaker.png"
                className="img-fluid"
              ></LazyLoadImage>
              <div
                className="position-absolute"
                style={{ bottom: 0, left: "2%" }}
              >
                <LazyLoadImage
                  src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/designCompetition/secondFoldFrontWebBreaker.jpg"
                  className="col-11 col-md-12"
                ></LazyLoadImage>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-8 my-lg-5">
            <h5 className="d-none d-lg-block">
              We’re inviting students across India to design funky, futuristic,
              and fabulous decals for our electric cycles. If you make the cut,
              your design could end up on a real EMotorad e-cycle!
            </h5>
            <p className="d-lg-none">
              We’re inviting students across India to design funky, futuristic,
              and fabulous decals for our electric cycles. If you make the cut,
              your design could end up on a real EMotorad e-cycle!
            </p>
          </div>
        </div>
        <div className="my-5 py-lg-4">
          <div className="box-gradient rounded-4">
            <div className="p-lg-5 p-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="col-12 col-md-6">
                  <h4 className="text-em text-center text-lg-start metropolis-bold mb-4">
                    Registrations Open: 18th–20th August 2025
                  </h4>
                  <p className="text-center text-lg-start">
                    Winning designs may be featured on real EMotorad e-cycles
                  </p>
                </div>
                <div className="d-none d-lg-block">
                  <Link
                    to={"/watt-a-design/register"}
                    type="button"
                    class="btn btn-outline-primary rounded-5 px-5 metropolis-medium"
                  >
                    Register Now!
                  </Link>
                </div>
              </div>
              <div className="d-lg-none mb-5">
                <div className="d-flex justify-content-center">
                  <Link
                    to={"/watt-a-design/register"}
                    type="button"
                    class="btn btn-outline-primary rounded-5 px-5 metropolis-medium"
                  >
                    Register Now!
                  </Link>
                </div>
              </div>
              <div>
                <h6 className="mb-4 metropolis-medium text-center text-lg-start">
                  Who can apply?
                </h6>
                <div>
                  <div
                    className="d-flex align-items-center mb-2"
                    style={{ gap: "0.5em" }}
                  >
                    <div>
                      <Icon
                        icon="mdi:tick-circle"
                        style={{
                          color: "#10B068",
                          width: "1.5em",
                          height: "1.5em",
                        }}
                      />
                    </div>
                    <p className="mb-0">You’re 18 or older</p>
                  </div>
                  <div
                    className="d-flex align-items-center mb-2"
                    style={{ gap: "0.5em" }}
                  >
                    <div>
                      <Icon
                        icon="mdi:tick-circle"
                        style={{
                          color: "#10B068",
                          width: "1.5em",
                          height: "1.5em",
                        }}
                      />
                    </div>
                    <p className="mb-0">You live in India</p>
                  </div>
                  <div
                    className="d-flex align-items-center mb-2"
                    style={{ gap: "0.5em" }}
                  >
                    <div>
                      <Icon
                        icon="mdi:tick-circle"
                        style={{
                          color: "#10B068",
                          width: "1.5em",
                          height: "1.5em",
                        }}
                      />
                    </div>
                    <p className="mb-0">
                      You’re a student (UG, PG, MBA or Engineering)
                    </p>
                  </div>
                  <div
                    className="d-flex align-items-center mb-2"
                    style={{ gap: "0.5em" }}
                  >
                    <div>
                      <Icon
                        icon="mdi:tick-circle"
                        style={{
                          color: "#10B068",
                          width: "1.5em",
                          height: "1.5em",
                        }}
                      />
                    </div>
                    <p className="mb-0">You’re applying solo (no teams)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="my-5 py-lg-4">
          <h4 className="metropolis-bold text-center d-lg-block d-none mb-4">
            Keep an Eye on these Key Dates
          </h4>
          <h5 className="metropolis-bold text-center d-lg-none mb-4">
            Keep an Eye on these Key Dates
          </h5>
          <div className="d-flex justify-content-center">
            <table class="custom-table">
              <thead>
                <tr>
                  <th className="text-center text-lg-start">What</th>
                  <th className="text-center text-lg-start">When</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Registration Ends</td>
                  <td>20th August 2025</td>
                </tr>
                <tr>
                  <td>Round 1 Submissions</td>
                  <td>21st – 25th August 2025</td>
                </tr>
                <tr>
                  <td>Top 20 Finalists Announcement</td>
                  <td>27th August 2025</td>
                </tr>
                <tr>
                  <td>Round 2 Submissions </td>
                  <td>28th August – 2nd September 2025</td>
                </tr>
                <tr>
                  <td>Winner Announcement</td>
                  <td>12th September 2025</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="my-5 py-lg-4">
          <div className="d-flex justify-content-around flex-column flex-lg-row">
            <div className="mb-5 mb-lg-0">
              <h2 className="metropolis-bold mb-4">Got Questions?</h2>
              <div
                className="d-flex align-items-center mb-3"
                style={{ gap: "0.5em" }}
              >
                <div>
                  <Icon
                    icon="material-symbols:mail"
                    width="1.2em"
                    height="1.2em"
                    style={{ color: "#004dac" }}
                  />
                </div>
                <a
                  href="mailto:designchallengehelpdesk@emotorad.com"
                  className="text-decoration-none text-muted"
                  style={{ color: "inherit" }}
                >
                  designchallengehelpdesk@emotorad.com
                </a>
              </div>
              <div
                className="d-flex align-items-center"
                style={{ gap: "0.5em" }}
              >
                <div>
                  <Icon
                    icon="material-symbols:call"
                    width="1.2em"
                    height="1.2em"
                    style={{ color: "#004dac" }}
                  />
                </div>

                <a
                  href="tel:+918956449775"
                  style={{ color: "inherit" }}
                  className="text-decoration-none text-muted"
                >
                  Urjaa Saha: +91 8956449775
                </a>
              </div>
            </div>
            <div>
              <LazyLoadImage
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/designCompetition/logo.jpg"
                className="img-fluid"
              ></LazyLoadImage>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BikeDesignCompScreen;
